import { useMemo } from 'react';
import { ApprovalUserType } from 'ui-product-approvals-common';
import { ACTOR } from '../constants/actors';
export const useCurrentUserType = (approvalData, currentUser) => useMemo(() => {
  var _currentUser$user_id;
  let result = ApprovalUserType.NON_PARTICIPANT;
  if (!approvalData) {
    return result;
  }
  if (approvalData.requester.actor.actorType === ACTOR.USER && approvalData.requester.actor.id === (currentUser === null || currentUser === void 0 || (_currentUser$user_id = currentUser.user_id) === null || _currentUser$user_id === void 0 ? void 0 : _currentUser$user_id.toString())) {
    result = ApprovalUserType.REQUESTER;
  } else if (approvalData.approvalSteps.length && approvalData.approvalSteps.some(approvalStep => {
    var _currentUser$user_id2;
    return approvalStep.approver.actor.actorType === ACTOR.USER && approvalStep.approver.actor.id === (currentUser === null || currentUser === void 0 || (_currentUser$user_id2 = currentUser.user_id) === null || _currentUser$user_id2 === void 0 ? void 0 : _currentUser$user_id2.toString());
  })) {
    result = ApprovalUserType.APPROVER;
  }
  return result;
}, [approvalData, currentUser]);